import template from './pipelineFiltersMobileModal.html';
import controller from '../pipelineFiltersCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    pipelineType: '<',
    pipelineTypes: '<',
    isCorporateUser: '<',
    statusListRadio: '<',
    settings: '<',
    substatusList: '<',
    advisersList: '<',
    assistantAdviserList: '<',
    showAssistantFilter: '<',
    labelsList: '<',
    probabilityList: '<',
    enquirySourceList: '<',
    referrerList: '<',
    isSmallDevice: '<',
    onChangeSettings: '&',
    onChangeExcludeColumnsSettings: '&',
    onChangeStatusSettings: '&',
  },
};
